import fetch from 'sync-fetch'
import { VIMEO_API_TOKEN } from '../constants'

const VIMEO_REGEX = /^(https?:\/\/)?(www\.|player\.)?(vimeo\.com)(?!\/@)(.+)?$/;
const YOUTUBE_REGEX = /^(https?:\/\/)?(www\.|music\.)?(youtube\.com|youtu\.be)(?!.*\/channel\/)(?!\/@)(.+)?$/;


const getVideoDimensions = (videoId: string, isYouTube: boolean = true, isShort: boolean = false) => {
  const url = isYouTube ?
    `https://www.youtube.com/oembed?url=https://www.youtube.com/${isShort ? `shorts/${videoId}` : `watch?v=${videoId}`}&format=json` :
    `https://api.vimeo.com/videos/${videoId}?fields=width,height,player_embed_url`;
  console.log("Fetching video dimensions from URL:", url); // Debugging line
  const response = fetch(
    isYouTube ?
      `https://www.youtube.com/oembed?url=https://www.youtube.com/${isShort ? `shorts/${videoId}` : `watch?v=${videoId}`}&format=json` :
      `https://api.vimeo.com/videos/${videoId}?fields=width,height,player_embed_url`,
    !isYouTube ? {
      headers: {
        Authorization: `Bearer ${VIMEO_API_TOKEN}`
      }
    } : {}
  );
  return response.json();
};

const isValidVideoUrl = (url) => {
  return YOUTUBE_REGEX.test(url) || VIMEO_REGEX.test(url) ? undefined : 'Invalid video URL. Only YouTube and Vimeo URLs are allowed.';
};
const getYoutubeEmbedUrl = (nocookie) => {
  return nocookie ? 'https://www.youtube-nocookie.com/embed/' : 'https://www.youtube.com/embed/';
};

const getEmbedUrlAndDimensions = (options) => {
  const { url, allowFullscreen, autoplay, ccLanguage, ccLoadPolicy, controls, disableKBcontrols, enableIFrameApi, endTime, interfaceLanguage, ivLoadPolicy, loop, modestBranding, nocookie, origin, playlist, progressBarColor, startAt, } = options;
  // if is already an embed url, return it
  if (url.includes('/embed/')) {
    return url;
  }
  // if is a youtu.be url, get the id after the /
  if (url.includes('youtu.be')) {
    const id = url.split('/').pop();
    if (!id) {
      return null;
    }
    const { width, height } = getVideoDimensions(id);

    return { url: `${getYoutubeEmbedUrl(nocookie)}${id}`, width, height };
  }
  if (url.includes('vimeo.com')) {
    let id = url.split('/').pop();
    if (!id) {
      return null;
    }
    if (id.includes('?')) id = id.substring(0, id.indexOf('?'))
    const { width, height, player_embed_url } = getVideoDimensions(id, false);
    return { url: player_embed_url, width, height };
  }

  const videoIdRegex = /(v=([-\w]+))|(shorts\/([-\w]+))/gm;
  const matches = videoIdRegex.exec(url);
  if (!matches || (!matches[2] && !matches[4])) {
    return null;
  }
  const { width, height, thumbnail_url } = getVideoDimensions(matches[2] || matches[4], true, !!matches[4])
  let outputUrl = `${getYoutubeEmbedUrl(nocookie)}${matches[2] || matches[4]}`;
  const params = [];
  if (allowFullscreen === false) {
    params.push('fs=0');
  }
  if (autoplay) {
    params.push('autoplay=1');
  }
  if (ccLanguage) {
    params.push(`cc_lang_pref=${ccLanguage}`);
  }
  if (ccLoadPolicy) {
    params.push('cc_load_policy=1');
  }
  if (!controls) {
    params.push('controls=0');
  }
  if (disableKBcontrols) {
    params.push('disablekb=1');
  }
  if (enableIFrameApi) {
    params.push('enablejsapi=1');
  }
  if (endTime) {
    params.push(`end=${endTime}`);
  }
  if (interfaceLanguage) {
    params.push(`hl=${interfaceLanguage}`);
  }
  if (ivLoadPolicy) {
    params.push(`iv_load_policy=${ivLoadPolicy}`);
  }
  if (loop) {
    params.push(`loop=1&playlist=${matches[2] || matches[4]}`);
  }
  if (modestBranding) {
    params.push('modestbranding=1');
  }
  if (origin) {
    params.push(`origin=${origin}`);
  }
  if (playlist) {
    params.push(`playlist=${playlist}`);
  }
  if (startAt) {
    params.push(`start=${startAt}`);
  }
  if (progressBarColor) {
    params.push(`color=${progressBarColor}`);
  }
  if (params.length) {
    outputUrl += `?${params.join('&')}`;
  }
  return { url: outputUrl, width, height, thumbnail_url };
};

export { isValidVideoUrl, getEmbedUrlAndDimensions };